import React from 'react';
import GiftCounter from './GiftCounter';

const GiftButton = ({ girlId, girlName, className = "" }) => {
  return (
    <GiftCounter
      girlId={girlId}
      girlName={girlName}
      className={className}
    />
  );
};

export default GiftButton;
